// const { log } = require('app-lib-log');
// const { exec } = require('app-lib-exec');

/**
 * 测试文档
 * 
 * @param {string } a  sass
 * @returns   asad
 * @function
 */
const test=(a)=>{
 return a;
}

// module.exports = {
//     log,
//     exec
// }
module.exports = {
    a:1
}

console.log("测试压缩")